<template>
  <!-- 编辑美孚 -->
  <Modal
    class="common-drawer newModal"
    v-model="value"
    :title="title"
    width="704px"
    :mask-closable="false"
    @on-cancel="closeModal"
  >
    <div v-if="isSpin" class="u-flex u-row-center Spin">
      <Spin />
    </div>
    <Row v-else>
      <Col :span="10">
        <div class="eit-lable">已选</div>
        <div class="edt-input">
          <Input
            @on-change="inputChange"
            v-model="FormData.innerMobilUserName"
            placeholder="请输入"
          />
        </div>
        <div class="eid-list">
          <template v-if="yxlist.length > 0">
            <template v-for="(item, key) in yxlist">
              <div
                class="eid-item"
                :class="{ 'bordr-none': yxlist.length - 1 == key }"
                v-if="item.isshow"
                :key="key"
              >
                <div style="width: 20px">
                  <Checkbox v-model="item.bo"> </Checkbox>
                </div>
                <div style="width: 100%">
                  <span class="item-check"> {{ item.name }}</span>
                </div>
                <div style="width: 180px">
                  <Dropdown @on-click="(name) => changeDrpdown(name, item)">
                    <a class="u-flex" href="javascript:void(0)">
                      {{ item.authorityString == "r" ? "可阅读" : "可编辑" }}
                      <Icon size="30" type="md-arrow-dropdown"></Icon>
                    </a>
                    <DropdownMenu slot="list">
                      <DropdownItem name="可阅读">可阅读</DropdownItem>
                      <DropdownItem name="可编辑">可编辑</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="mw mh u-flex u-row-center">暂无数据</div>
          </template>
        </div>
        <div class="chec-bottom">
          <Checkbox
            @on-change="leftchange"
            :indeterminate="leftObj.der"
            v-model="leftObj.bo"
          >
            <span class="item-check"> 全选</span>
          </Checkbox>
          <div class="">已选择的{{ leftObj.text }}项</div>
        </div>
      </Col>
      <Col :span="4">
        <div class="arr-icons">
          <div
            class="arr-icon lua-cus"
            style="margin-bottom: 4px"
            @click="addList()"
            :class="{ 'arr-icon-blue': rightObj.btn }"
          >
            <Icon
              class="lua-icon"
              style="left: 0"
              color="#ffffff"
              type="ios-arrow-back"
            />
          </div>
          <div
            class="arr-icon lua-cus"
            @click="removeList()"
            :class="{ 'arr-icon-blue': leftObj.btn }"
          >
            <Icon
              class="lua-icon"
              style="left: 1.5px"
              color="#ffffff"
              type="ios-arrow-forward"
            />
          </div>
        </div>
      </Col>
      <Col :span="10">
        <div class="eit-lable">候选</div>
        <div class="edt-input">
          <Input
            v-model="FormData.candiDatelUserName"
            @on-change="candinputChange"
            placeholder="请输入"
          />
        </div>
        <div class="eid-list">
          <template v-if="wxlist.length > 0">
            <template v-for="(item, key) in wxlist">
              <div
                class="eid-item"
                :class="{ 'bordr-none': wxlist.length - 1 == key }"
                :key="key"
                  v-if="item.isshow"
              >
                <!-- <Checkbox v-model="item.bo" size="small"></Checkbox>&nbsp; -->
                <Checkbox v-model="item.bo"> </Checkbox>
                <span class="item-check"> {{ item.name }}</span>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="mw mh u-flex u-row-center">暂无数据</div>
          </template>
        </div>
        <div class="chec-bottom">
          <!-- <Checkbox @on-change="leftchange" 
          :indeterminate="leftObj.der" v-model="leftObj.bo"> -->
          <Checkbox
            @on-change="rightchange"
            :indeterminate="rightObj.der"
            v-model="rightObj.bo"
          >
            <span class="item-check"> 全选</span>
          </Checkbox>
          <div class="">已选择的{{ rightObj.text }}项</div>
        </div>
      </Col>
    </Row>
    <div class="drawer-footer" slot="footer">
      <Button type="primary" @click="sumit()" :loading="btnLoading"
        >提交</Button
      >
      <Button style="margin-left: 8px" @click="closeModal()">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { _groupmobillist, _groupconsumerDit } from "@/api/system/limitauth.js";
export default {
  props: ["value", "paraForm", "getList"],
  data() {
    return {
      isSpin: true,
      title: "编辑用户",
      btnLoading: false,
      FormData: {
        innerMobilUserName: "",
        outerMobilUserName: "",
      },
      leftObj: {
        bo: false,
        text: "0",
        btn: false, //全选
        der: false,
      },
      rightObj: {
        bo: false,
        text: "0",
        btn: false,
        der: false,
      },
      yxlist: [],
      wxlist: [],
    };
  },

  watch: {
    value: {
      handler: function (value) {
  
        if (value) {
          this.getlist();
        }
      },
    },
    yxlist: {
      deep: true,
      immediate: true,
      handler: function (arr) {
        let lenth = arr.filter((e) => e.isshow).length;
        let itemar = arr.filter((e) => e.isshow).filter((e) => e.bo);
        let bolenth = itemar.length;
        let leftObj1 = {
          bo: false,
          text: bolenth || 0,
          btn: false, //全选
          der: false,
        };
        if (lenth == 0) {
          this.leftObj = leftObj1;
          return;
        }
        if (lenth == bolenth) {
          leftObj1.bo = true;
          leftObj1.der = false;
          leftObj1.btn = true;
        } else if (bolenth > 0) {
          leftObj1.bo = false;
          leftObj1.der = true;
          leftObj1.btn = true;
        }
        this.leftObj = leftObj1;

      },
    },
    wxlist: {
      deep: true,
      immediate: true,
      handler: function (arr) {
        let lenth = arr.filter((e) => e.isshow).length;
        let itemar = arr.filter((e) => e.isshow).filter((e) => e.bo);
        let bolenth = itemar.length;
        let rightObj = {
          bo: false,
          text: bolenth || 0,
          btn: false, //全选
          der: false,
        };
        if (lenth == 0) {
          this.rightObj = rightObj;
          return;
        }
        if (lenth == bolenth) {
          rightObj.bo = true;
          rightObj.der = false;
          rightObj.btn = true;
        } else if (bolenth > 0) {
          rightObj.bo = false;
          rightObj.der = true;
          rightObj.btn = true;
        }
        this.rightObj = rightObj;

      },
    },
  },
  methods: {
    candinputChange() {
      let value = this.FormData.candiDatelUserName;
   
      if (!value) {
        this.wxlist = this.wxlist.map((e) => {
          e.isshow = true;
          return e;
        });
      } else {
        this.wxlist = this.wxlist.map((item) => {
          item.isshow = false;
          if (item.name.includes(value)) {
            item.isshow = true;
          }
          return item;
        });
      }
    },
    
    changeDrpdown(name, row) {
      if (name == "可阅读") {
        row.authorityString = "r";
      } else {
        row.authorityString = "rw";
      }
    },
    inputChange() {
      let value = this.FormData.innerMobilUserName;
      if (!value) {
        this.yxlist = this.yxlist.map((e) => {
          e.isshow = true;
          return e;
        });
      } else {
        this.yxlist = this.yxlist.map((item) => {
          item.isshow = false;
          if (item.name.includes(value)) {
            item.isshow = true;
          }
          return item;
        });
      }
    },
    async getlist() {
      this.isSpin = true;

      let { data } = await _groupmobillist({ groupId: this.paraForm.id });
      let { innerMobilUserList, outerMobilUserlist } = data;
      this.yxlist = this.addjudgment(innerMobilUserList, 0);
      this.wxlist = this.addjudgment(outerMobilUserlist, 1);
      this.isSpin = false;
    },
    addjudgment(arr, status) {
      if (arr) {
        return arr.map((e) => {
          e.name = e.nickname;
          e.bo = false;
          e.isshow = true;
          e.authorityString = status == 1 ? "r" : e.groupAuthorityString;
          return e;
        });
      }
    },
    leftchange(bo) {
      let value = this.FormData.innerMobilUserName;
       if(!value){
          this.yxlist = this.yxlist.map((item) => {
        item.bo = bo;
        return item;
      });
       }else{
         this.yxlist = this.yxlist.map((item) => {
          if(item.isshow){
             item.bo = bo;
          }
          return item;
        });
       }
    },
    rightchange(bo) {
       let value = this.FormData.candiDatelUserName;
      if (!value) {
        this.wxlist = this.wxlist.map((item) => {
          item.bo = bo;
          return item;
        });
      }else{
         this.wxlist = this.wxlist.map((item) => {
          if(item.isshow){
             item.bo = bo;
          }
          return item;
        });
      }
    },
    closeModal() {
      this.$emit("input", false);
    },
    async sumit() {
      if (this.yxlist.length == 0) {
        this.$Message.info("请选择客户");
        return;
      }
      let mobilGroupQuerys = this.yxlist.map((e) => {
        return {
          mobilUserId: e.id,
          authorityString: e.authorityString,
        };
      });
      let obj = {
        groupId: this.paraForm.id,
        mobilGroupQuerys,
      };
      let data = await _groupconsumerDit({ ...obj });

      if (data.code == "00000") {
        this.$Message.success("操作成功");
        this.closeModal();
        this.getList();
      } else {
        this.$Message.info("操作成功");
      }
    },
    removeList() {
      const { btn } = this.leftObj;
      if (btn) {
        let yxarr = this.$c
          .deepClone(this.yxlist)
          .filter((e) => e.bo)
          .map((e) => {
            e.bo = false;
            return e;
          });
        this.yxlist = this.yxlist.filter((e) => !e.bo);
       
        this.wxlist = [...yxarr, ...this.wxlist];
      } else {
        this.$Message.info("请选择要移除的元素");
      }
    },
    addList() {
      const { btn } = this.rightObj;
      if (btn) {
        let wxarr = this.$c
          .deepClone(this.wxlist)
          .filter((e) => e.bo)
          .map((e) => {
            e.bo = false;
            return e;
          });
      
        this.wxlist = this.wxlist.filter((e) => !e.bo);
       
        this.yxlist = [...wxarr, ...this.yxlist];
      } else {
        this.$Message.info("请选择要加入的元素");
      }
    },
  },
};
</script>

  <style lang='less' scoped>
.eit-lable {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.851);
  margin-bottom: 12px;
}
.edt-input {
  margin-bottom: 12px;
}
.eid-list {
  width: 100%;
  height: 256px;
  overflow-y: scroll;
}
.eid-item {
  width: 100%;
  display: flex;
  align-items: center;
  padding:5px;
  border-bottom: 1px solid #ebebeb;
}
.bordr-none {
  border-bottom: none !important;
}
.item-check {
  position: relative;
  left: 10px;
}
.chec-bottom {
  width: 100%;
  padding: 8px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #ebebeb;
  font-size: 12px;
}
.arr-icons {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .arr-icon-blue {
    background: rgba(33, 101, 193, 1) !important;
  }

  .arr-icon {
    width: 16px;
    height: 16px;
    background: rgba(210, 213, 217, 1);

    .lua-icon {
      position: relative;
      top: -3px;
    }
  }
}
.Spin {
  width: 100%;
  height: 502px;
}
</style>